import { AppEvent } from 'types/appEvent';
import { OrgInfoFormValues } from 'types/orgInfoTypes';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextOrgInfoFormValues = createReducer<
  OrgInfoFormValues,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'ProdStackManager__OrgInfoFormValuesChanged':
      return event.nextValues;
    default:
      return prev;
  }
});
